"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ChangeTableViewButton", {
  enumerable: true,
  get: function get() {
    return _ChangeTableViewButton.ChangeTableViewButton;
  }
});

var _ChangeTableViewButton = require("./ChangeTableViewButton.connect");